module.exports = __webpack_public_path__ + "static/banner-sm-c338200bd58df32416f42a89a8c6afe1.jpg";